export const PLUGIN_NAMESPACE = 'ssrx';
